import moment from 'moment';

export type Direction = 'up' | 'down' | 'neutral';

export function calculateDailyAverage(total: number | undefined, days: number): number {
  if (!total || days <= 0) return 0;
  return total / days;
}

export function calculatePercentageChange(
  projected: number,
  comparison: number,
  isIncreaseBad = false,
): { percentage: number; direction: Direction } {
  if (comparison === 0) {
    if (isIncreaseBad) {
      return { percentage: 0, direction: projected < 0 ? 'down' : 'neutral' };
    }
    return { percentage: 0, direction: projected > 0 ? 'up' : 'neutral' };
  }
  const percentage = ((projected - comparison) / comparison) * 100;
  const increaseDirection: Direction = isIncreaseBad ? 'down' : 'up';
  const decreaseDirection: Direction = isIncreaseBad ? 'up' : 'down';
  const direction: Direction = percentage > 0 ? increaseDirection : percentage < 0 ? decreaseDirection : 'neutral';
  return { percentage: Math.round(percentage), direction };
}

export function getDaysInfo() {
  const now = moment();
  const dayOfMonth = now.date();
  const daysInCurrentMonth = now.daysInMonth();

  const prevMonth = moment().subtract(1, 'month');
  const daysInPreviousMonth = prevMonth.daysInMonth();

  const sameMonthLastYear = moment().subtract(1, 'year');
  const daysInSameMonthLastYear = sameMonthLastYear.daysInMonth();
  const sameMonthLastYearLabel = sameMonthLastYear.format('MMM YYYY');

  return { dayOfMonth, daysInCurrentMonth, daysInPreviousMonth, daysInSameMonthLastYear, sameMonthLastYearLabel };
}
